export default {
  name: 'tooltip',
  props: {
    strArray: [Array, String]
  },
  render (h) {
    let strArr = this.strArray
    if (typeof strArr === 'object') {
      let warp = h('br')
      let tooltipStrs = []
      strArr.forEach((element, index) => {
        tooltipStrs.push(h('span', {
          domProps: {
            innerHTML: element
          }
        }))

        if (index >= 0 && index < strArr.length - 1) {
          tooltipStrs.push(warp)
        }
      })
      return h('div', {
        style: {
          display: 'inline-block'
        }
      }, tooltipStrs)
    } else {
      return h('div', {
        style: {
          display: 'inline-block'
        },
        domProps: {
          innerHTML: strArr
        }
      })
    }
  }
}
